import type { AuthResponse, RefreshTokenResponse } from 'src/contracts/auth';
import type { ApiResponse } from 'src/contracts/common';

import { flatten, apiClient } from 'src/lib/api-client';

// Export RegisterData type for backward compatibility
export interface RegisterData {
  firstName: string;
  lastName: string;
  email: string;
  password: string;
  verificationCode?: string;
}

/** Signs in or up: the token, user and roles come back under `data`. */
const session = async (endpoint: string, body: unknown): Promise<AuthResponse> =>
  flatten(await apiClient.post<any>(endpoint, body));

export const authApi = {
  login: async (email: string, password: string) => {
    try {
      const response = await session('/auth/login', { email, password });
      console.log('Login API response:', response);
      return response;
    } catch (error) {
      console.error('Login API error:', error);
      throw error;
    }
  },

  loginWithGoogle: async (googleToken: string) => session('/auth/google', { googleToken }),

  register: async (firstName: string, lastName: string, email: string, password: string) =>
    session('/auth/register', { firstName, lastName, email, password }),

  // For backward compatibility - accepts a RegisterData object
  registerWithData: async (data: RegisterData) => session('/auth/register', data),

  refreshToken: async (): Promise<RefreshTokenResponse> =>
    flatten(await apiClient.post<any>('/auth/refresh-token', {})),

  forgotPassword: async (email: string) =>
    apiClient.post<ApiResponse<void>>('/auth/forgot-password', { email }),

  resetPassword: async (token: string, newPassword: string) =>
    apiClient.post<ApiResponse<void>>('/auth/reset-password', { token, newPassword }),

  // Legacy methods for backward compatibility
  googleLogin: async (credential: string) =>
    session('/auth/google', { credential }),

  sendVerificationCode: async (email: string) =>
    apiClient.post<ApiResponse<void>>('/auth/send-verification', { email }),
};
